<template>
  <transition :name="animation">
    <div
      v-if="isActive"
      class="dialog modal is-active">
      <div class="modal-background">
        <div class="modal-card animation-content">
          <section class="modal-card-body is-titleless has-background-dark has-text-white">
            <p v-html="message"></p>
          </section> 
          <footer class="modal-card-foot has-background-dark">
            <button
              @click.prevent="cancel"
              class="button is-danger is-rounded">
              {{cancelText}}
            </button>
            <button
              @click.prevent="confirm"
              class="button is-success is-rounded">
              {{confirmText}}
            </button>
          </footer>           
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    animation: {
      type: String,
      default: 'zoom-out'
    },
    cancelText: {
      type: String,
      default: 'Nej'
    },
    confirmText: {
      type: String,
      default: 'Ja'
    },
    message: String
  },
  data() {
    return {
      isActive: false
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    }
  },
  mounted() {
    this.isActive = true
  }
}
</script>
<style lang="scss" scoped>
  .modal-background {
    background: rgba(255, 255, 255, 0.2);
  }
  .modal-card {
    width: 300px;
    top: 50%;
    margin: 0 auto;
    transform: translateY(-50%);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    
    .modal-card-body {
      padding: 2rem 2rem 1rem 2rem;
    }

    .modal-card-foot {
      justify-content: space-between;
      border-top: none;
      padding: 0 2rem 2rem 2rem;
      border-bottom-left-radius: 6px;
    }
  }
</style>
